export const desktopProcessErrorCodeText: { [key: string]: string } = {
    API_URL_NOT_WHITELISTED: '',
    UNEXPECTED_CONTENT_TYPE: '',
    SOFTWARE_ALREADY_RUNNING: 'De software is al opgestart',
    PARAMS_NOT_VALID: '',
    GOT_ERROR:
        'Er is iets mis gegaan met de verbinding van de elektrocardiograaf. Probeer het opnieuw of neem contact op met de Servicedesk dan zoeken we het voor je uit.',
    CARDIOPERFECT_ONLY_ON_WINDOWS:
        'Je kunt de koppeling met de elektrocardiograaf alleen op een Windows computer gebruiken.',
    PATH_TO_SOFTWARE_NOT_FOUND:
        'Er is iets mis gegaan  met de verbinding van de elektrocardiograaf. Probeer het opnieuw of neem contact op met de Servicedesk dan zoeken we het voor je uit.',
    FAILED_TO_START_CARDIOPERFECT:
        'Er is iets mis gegaan met de verbinding van de elektrocardiograaf. Probeer het opnieuw of neem contact op met de Servicedesk dan zoeken we het voor je uit.',
    FAILED_TO_READ_CARDIOPERFECT_OUTPUT_FILE:
        'Er is iets mis gegaan  met de verbinding van de elektrocardiograaf. Probeer het opnieuw of neem contact op met de Servicedesk dan zoeken we het voor je uit.',
    CARDIOPERFECT_OUTPUT_FILE_HAS_ERROR:
        'Er is iets mis gegaan  met de verbinding van de elektrocardiograaf. Probeer het opnieuw of neem contact op met de Servicedesk dan zoeken we het voor je uit.',
};
